import React from 'react';
import { NavLink } from 'react-router-dom';
import { translate } from '../translations';
import { getTheme } from '../Theme';

import projectUE1 from '../images/ue1.png';
import projectUE2 from '../images/ue2.png';
import projectUE3 from '../images/ue3.png';
import projectUE4 from '../images/ue4.png';
import firstEngine from '../images/silnik1.jpg';

const lorem =
  ' Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aeneanvulputate, ipsum at luctus mattis, est urna dapibus lacus, sit ametsollicitudin ligula ante efficitur risus. In facilisis semper gravida.Quisque quis velit viverra, volutpat tellus sed, malesuada elit. Nammolestie nisi et ante elementum interdum. Lorem ipsum dolor sit amet,consectetur adipiscing elit. Nam id aliquam dui. Quisque sit ametfelis eleifend, posuere arcu nec, sodales nunc. Vivamus varius dolorlorem, sit amet elementum urna volutpat sit amet. Vivamus sit ametlorem sit amet massa interdum placerat. Nunc laoreet nibh et hendrerit venenatis';

const data = [
  // {
  //   title: 'Lorem ipsum dolor si',
  //   content: lorem,
  //   image: '',
  //   tags: ['Silniki', 'Badania'],
  // },
  // {
  //   title: 'Srolem dupsum dolor',
  //   content: lorem,
  //   image: '',
  //   tags: ['Silniki', 'Badania', 'Wydarzenia'],
  // },
];

const Tag = props => {
  const { name } = props;

  switch (name) {
    case 'Silniki':
      return <div className={'tag engines'}>{name}</div>;
    case 'Wydarzenia':
      return <div className={'tag events'}>{name}</div>;
    case 'Badania':
      return <div className={'tag research'}>{name}</div>;
    default:
      return null;
  }
};

const Article = props => {
  const { title, image, tags, content } = props;
  return (
    <article>
      <h2>{title}</h2>
      <div className="article-content">
        <img src={firstEngine} alt="article" />
        <p>{content}</p>
      </div>
      <div className="tags">
        {tags.map(tag => (
          <Tag name={tag} key={tag} />
        ))}
      </div>
      <div className="border"></div>
    </article>
  );
};

const Home = () => {
  return (
    <>
      <section id="home">
        <div className={getTheme('ue-title-container')}>
          <div className="container" style={{ marginTop: '40px' }}>
            <h1 className="ue-header">
              {translate(
                'Od 16.01.2020. Filipek Filipek-Motors Sp. z o.o. realizuje projekt:'
              )}
            </h1>
            <h2 className="ue-title">
              {translate(
                'Zaprojektowanie i badania silników prądu stałego i prądnic LMB'
              )}
              <br />
            </h2>
            <h3 className="ue-title-description">
              {translate('Projekt nr: POIR.01.01.01-00-0245/19')}
              <br />
              {translate(
                'współfinansowany ze środków Europejskiego Funduszu Rozwoju Regionalnego'
              )}
              <br />
              {translate(
                'w ramach ”Programu Operacyjnego Inteligentny Rozwój 2014 – 2020”.'
              )}
              <br />
            </h3>
            <br />
            <h4 className="ue-home-h4">
              {translate('więcej informacji w zakładce')}{' '}
              <NavLink className="ue-home-href" exact to="/Project">
                Projekt
              </NavLink>
            </h4>
          </div>
        </div>

        <div className="container">
          <div className={getTheme('ue-img-container')}>
            <div className="col-md-6">
              <div className="col-inner-spaceBetween">
                <img
                  className="ue-img ue-img-left"
                  src={projectUE1}
                  alt={'project'}
                />
                <img className="ue-img" src={projectUE2} alt={'project'} />
              </div>
            </div>
            <div className='col-md-6'>
            <div className='col-inner-spaceBetween'>
              <a style={{margin:'auto'}} title='https://www.ncbr.gov.pl/' href='https://www.ncbr.gov.pl/'>
                <img className='ue-img' src={projectUE3} alt={'project'} />
              </a>
              <img className='ue-img ue-img-right' src={projectUE4} alt={'project'}/>
            </div>
            </div>
          </div>
        </div>
      </section>
      {/* {data.map((article) => {
            const { title, image, tags, content } = article;
            return (
              <Article
                title={title}
                image={image}
                tags={tags}
                content={content}
                key={title}
              />
            );
          })}
     
        <div className='horizontal-separator'></div> */}
      {/* <section className='side-section'>
          <div className='archive'>
            <div className='header'>
              <h2>{translate('Archiwum')}</h2>
            </div>
            <div className='content'>
              <div className='side-element'>Sierpień 2020</div>
              <div className='border'></div>
              <div className='side-element'>Czerwiec 2020</div>
              <div className='border'></div>
              <div className='side-element'>Maj 2020</div>
              <div className='border'></div>
              <div className='side-element'>Kwiecień 2020</div>
              <div className='border'></div>
            </div>
          </div>
          <div className='categories'>
            <div className='header'>
              <h2>{translate('Kategorie')}</h2>
            </div>
            <div className='categories'>
              <div className='header'>
                <h2>{translate('Kategorie')}</h2>
              </div>
              <div className='content'>
                <div className='side-element'>Silniki</div>
                <div className='border'></div>
                <div className='side-element'>Badania</div>
                <div className='border'></div>
                <div className='side-element'>Wydarzenia</div>
                <div className='border'></div>
              </div>
            </div>
          </div>
        </section> */}
    </>
  );
};

export default Home;
